import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as _ from "lodash";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { BudgetCodeService } from "../../../shared/services/budget-code.service";
import { SubSink } from "subsink";

@Component({
    selector: "nbc-budget-code",
    templateUrl: "nbc-budget-code.component.html",
    standalone: false
})
export class NbcBudgetCodeComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private _BudgetService: BudgetCodeService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;
    public sub = new SubSink();

    wbsecodes: any = [];
    chargeCodeType = "N";
    chargeCodeTypes: any = [];
    companyCode: any;
    budgetQuery: any;

    showResultsContents = false;
    isBudgetFormSubmitted = false;

    getChargeCodes() {
        this.chargeCodeTypes = [
            {
                id: 0,
                name: 0,
                description: "N",
            },
            {
                id: 0,
                name: 0,
                description: "K",
            },
            {
                id: 0,
                name: 0,
                description: "M",
            },
            {
                id: 0,
                name: 0,
                description: "R",
            },
            {
                id: 0,
                name: 0,
                description: "T",
            },
            {
                id: 0,
                name: 0,
                description: "W",
            },
        ];
    }

    getCompanyCodes() {
        this.sub.sink = this._BudgetService.getCompanyCodes().subscribe({
            next: (result: any) => {
                this.companyCode = result.reference;
            },
            error: (err) => {
                this.log.showError("got an error: ");
            },
        });
    }

    getBudgetQuery() {
        return {
            pageSize: 10,
            currentPage: 1,
            code: "",
            description: "",
            coCode: "",
            //startAirDate: "",
            //endAirDate: ""
        };
    }

    isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
    }

    // Methods
    isOneFieldEntered() {
        if (
            this.isEmptyOrSpaces(this.budgetQuery.code) &&
            this.isEmptyOrSpaces(this.budgetQuery.description) &&
            (this.budgetQuery.coCode === "" || this.budgetQuery.coCode === 0)
        ) {
            return false;
        } else if (
            (this.budgetQuery.coCode === "Select Company Code" ||
                this.budgetQuery.coCode === 0) &&
            this.isEmptyOrSpaces(this.budgetQuery.description) &&
            this.isEmptyOrSpaces(this.budgetQuery.code)
        ) {
            return false;
        }
        return true;
    }

    budgetSearch(budgetForm) {
        if (budgetForm == undefined) return;

        this.log.trace("search()");
        this.isBudgetFormSubmitted = true;
        if (this.isOneFieldEntered()) {
            if (
                this.budgetQuery.coCode === "Select Company Code" ||
                this.budgetQuery.coCode === 0
            ) {
                this.budgetQuery.coCode = "";
            }

            const query = _.cloneDeep(this.budgetQuery);
            this.sub.sink = this._BudgetService.search(query).subscribe({
                next: (result: any) => {
                    this.wbsecodes = result;
                    this.budgetQuery.currentPage = result.currentPage;
                    this.showResultsContents = true;
                },
                error: (err) => {
                    this.log.showError("got an error: ");
                },
            });
        }
    }

    resetBudgetSearch(budgetForm) {
        this.log.trace("resetBudgetSearch()");
        this.isBudgetFormSubmitted = false;
        this.budgetQuery = _.cloneDeep(this.getBudgetQuery());
        this.wbsecodes = [];
        this.showResultsContents = false;
        this.chargeCodeType = "N";
    }
    selectWbseCode(wbsecode) {
        wbsecode.code =
            wbsecode.coCode + "." + this.chargeCodeType + "." + wbsecode.code;
        this.onSync.next(wbsecode);
        this.bsModalRef.hide();
    }

    // Modal Confirm Action
    confirm() {
        this.log.trace("Modal Confirmation Confirmed");
        this.onSync.next(true);
        this.bsModalRef.hide();
    }

    cancel() {
        this.log.trace("Modal Confirmation Cancelled");
        this.bsModalRef.hide();
    }

    ngOnInit() {
        this.onSync = new Subject();
        this.getCompanyCodes();
        this.getChargeCodes();
        this.budgetQuery = this.getBudgetQuery();
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
